module.exports = __webpack_public_path__ + "assets/7d8ae9c7770cdfa9cd39be79fecb618b.png";